<template>
    <div class="ssq-yc-page">
        <div class="tit">
            <span>1.填写标题</span>
            <span>温馨提示：每个指标都必须预测。</span>

        </div>

        <div class="qihao">
            [{{ vuex_userInfo.userName }}]双色球第{{ form.number }}期缩水师预测
            <!-- <input type="text"
                   v-model="form.title"> -->
        </div>
        <div class="notice">发缩水单在开奖当天18:00点截止，重新上传或者编辑到我的专栏</div>
        <div class="tit">
            <span>2.预测列表</span>
            <span>温馨提示：每个指标都需要预测</span>
            <div class="links">
                <span style="cursor: pointer;" @click="$router.push('/article_details?id=27&type=help')">收费标准</span>
                <span style="cursor: pointer;" @click="$router.push('/article_details?id=51&type=help')">积分规则</span>
                <span style="cursor: pointer;" @click="$router.push('/article_details?id=47&type=help')">阶梯提成</span>
            </div>
        </div>
        <el-dialog title="软件格式" :visible.sync="showImgDialog" width="60%" center>
            <div class="format-img-box">
                <img class="format-img" src="@/assets/imglog/ssq.png" />
            </div>
        </el-dialog>

        <div class="table-wrap">
            <div class="list" v-loading="uploadFile_loading">
                <div class="row head">
                    <span>预测指标</span> <span>操作</span>
                </div>
                <div class="row">
                    <span>90-99.9万</span>
                    <span><input type="file" data-type="7" data-fileType="pre_index_double_nine_w" accept=".txt"
                            @change="chooseFile"></span>
                </div>
                <div class="row">
                    <span>80-89.9万</span>
                    <span><input type="file" data-type="0" data-fileType="pre_index_double_eighty_w" accept=".txt"
                            @change="chooseFile"> </span>
                </div>
                <div class="row">
                    <span>50-59.9万</span>
                    <span> <input type="file" data-type="1" data-fileType="pre_index_double_fifty_w" accept=".txt"
                            @change="chooseFile"></span>
                </div>
                <div class="row">
                    <span>15-21.9万</span>
                    <span> <input type="file" data-type="2" data-fileType="pre_index_double_fifteen_w" accept=".txt"
                            @change="chooseFile"></span>
                </div>
                <div class="row">
                    <span>4-9.9万</span>
                    <span> <input type="file" data-type="3" data-fileType="pre_index_double_four_w" accept=".txt"
                            @change="chooseFile"></span>
                </div>
                <div class="row">
                    <span>5005注以下</span>
                    <span> <input type="file" data-type="4" data-fileType="pre_index_double_five_k" accept=".txt"
                            @change="chooseFile"></span>
                </div>
                <div class="row inp"><span>杀6蓝</span>
                    <span>
                        <div class="sha6">
                            <span v-for="(item, index) in sha6" :key="index" @click="C_num('sha6', index, item.ischeck,)"
                                :class="{ ischeck: item.ischeck, gray: item.gray, }">{{ item.num }}</span>
                        </div>
                        <div v-if="select.sha6">已选择：{{ select.sha6 }}</div>
                        <div>
                            <!-- <el-button @click="suiji(6)" type="primary" size="small">随机</el-button> -->
                            <el-button @click="confirm(6)" type="success" size="small">确定</el-button>
                            <el-button @click="reset(6)" type="danger" size="small">重置</el-button>
                        </div>
                        <!-- <input type="text"
                               data-type="5"
                               data-fileType="pre_index_double_six"
                               accept=".txt"
                               @blur="jianting_inp"> -->
                        <!-- <div>请输入要杀掉的 <b>6</b> 个篮球 (球号之间以空格分开) </div> -->
                    </span>
                </div>
                <div class="row inp">
                    <span>围4蓝</span>
                    <span>
                        <div class="sha4">
                            <span v-for="(item, index) in wei4" :key="index" @click="C_num('wei4', index, item.ischeck,)"
                                :class="{ ischeck: item.ischeck, gray: item.gray, }">{{ item.num }}</span>
                        </div>

                        <div v-if="select.wei4">已选择：{{ select.wei4 }}</div>

                        <div>
                            <!-- <el-button @click="suiji(4)" type="primary" size="small">随机</el-button> -->
                            <el-button @click="confirm(4)" type="success" size="small">确定</el-button>
                            <el-button @click="reset(4)" type="danger" size="small">重置</el-button>
                        </div>

                        <!-- <input type="text"
                               data-type="6"
                               data-fileType="pre_index_double_four"
                               accept=".txt"
                               @blur="jianting_inp"> -->
                        <!-- <div>请输入要围的 <b>4</b> 个篮球 (球号之间以空格分开) </div> -->
                    </span>
                </div>
            </div>

            <!-- 辅助说明区：桌面端绝对定位在表格右侧，移动端落到表格下方 -->
            <div class="aside">
                <span class="cttitle" @click="showImgDialog = true">系统默认天云和大赢家这样主流软件格式</span>
                <a class="cttitle ctitle2"
                    href="http://6.36886.net/stage-api/profile/upload/1/41/pre_other_file/2024/10/24/天云双色集合运算_20241024141145A007.zip"
                    download>下载天云双色</a>
                <span class="tish">
                    <span>发单格式:期数+用户名+注数</span>
                    <span>实例:2024115-李小龙-88.8万</span>
                    <b>温馨提示:用电信网络上传文件速度较快</b>
                </span>
            </div>
        </div>

        <div class="remark">
            <span class="remark-label">预测说明</span>
            <textarea v-model="form.preRemark" class="remark-input" rows="10"
                placeholder="温馨提示:可以介绍自己没有使用常规条件，极限条件等危险条件过滤,而是采用比较稳妥的分布过滤，冷码过滤，一级容错，二级容错，甚至三级容错技术，自我评估本期多大的单又多大的把握，提高自己的被认购率"></textarea>
        </div>

        <el-button type="primary" class="submit-btn" @click="save" v-loading="saveLoading">确定发布
        </el-button>
    </div>
</template>

<script>

import Mixin from '@/views/personalCenter/sss_yuce/minix'


import { queryUuIdInfo, upLoadFile } from "@/api/common"
import { queryNumber, savePreRecordInfo } from "@/api/personalCenter.js"


let mixin = new Mixin({
    lotteryType: '0',    //彩种
    lotteryName: '双色球',    //彩种
})
export default {
    mixins: [mixin],
    name: 'ssq',
    data() {
        return {
            showImgDialog: false,

            sha6: Array.from({ length: 16 }, (v, i) => {
                return { num: i + 1, ischeck: false, gray: false }
            }),
            wei4: Array.from({ length: 16 }, (v, i) => {
                return { num: i + 1, ischeck: false, gray: false }
            }),

            select: {
                sha6: '',
                wei4: '',
            },

        }
    },
    mounted() {
    },
    methods: {
        async confirm(type) {
            let activeArr = this[type == 6 ? 'sha6' : 'wei4'].filter(item => item.ischeck).map(item => item.num)

            if (type == 6 && activeArr.length < 6) {
                return this.$message.error(`请选择${type}个篮球`)
            }

            this.select[type == 6 ? 'sha6' : 'wei4'] = padZeros(activeArr).join(' ')
            // this.select[ type == 6 ? 'sha6' : 'wei4'] = activeArr.join(' ')

            let { number, recordId } = this.form;

            this.form.preRecordDetailDtoList.push({
                id: await queryUuIdInfo(),
                title: `双色球第（${number}）期缩水预测 `,
                // realBetNumber:'' ,     //文件行数上传文件成功后有返回
                preIndexType: type == 4 ? 6 : 5,		//指标标识
                number,
                preType: 0,	//彩种
                expand: this.select[type == 4 ? 'wei4' : 'sha6'],	//输入的数字   围3杀5这些

                createUser: this.vuex_userInfo.userId,
                productModel: '0', //商品所属模块：商品类别:0（预测缩水单商品），1（EXCEL专场商品），2（缩水软件特区商品；【product_model】
                backNumber: '20',
            })


            function padZeros(arr) {
                return arr.map(num => {
                    // 将数字转换为字符串
                    const str = num.toString();
                    // 如果字符串长度小于2，则在前面补0
                    return str.length < 2 ? `0${str}` : str;
                });
            }

        },
        // 重置
        reset(type) {
            this[type == 6 ? 'sha6' : 'wei4'] = Array.from({ length: 16 }, (v, i) => {
                return { num: i + 1, ischeck: false, gray: false }
            })
            this[type == 6 ? 'wei4' : 'sha6'].forEach(item => item.gray = false)

            this.select[type == 6 ? 'sha6' : 'wei4'] = ''

        },

        // 杀6围4
        C_num(type, index, ischeck) {
            if (this[type][index].gray) return;
            if (ischeck == false) {
                if (this[type].filter(item => item.ischeck).length >= (type == 'sha6' ? 6 : 4)) {
                    return this.$message.error(`最多选择${(type == 'sha6' ? 6 : 4)}个篮球`)
                }
            }
            this.$set(this[type][index], 'ischeck', !ischeck)
            this.$set(this[type == 'sha6' ? 'wei4' : 'sha6'][index], 'gray', !ischeck)
        },
    }
};
</script>

<style lang="scss" scoped>
@use './yuce.scss';

/* ===== 页面容器 ===== */
.ssq-yc-page {
	max-width: 900px;
}

</style>
